const Spinner = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <div className="scroll-spinner">
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
    </div>
    <style jsx>{`
      .scroll-spinner {
        display: flex;
        gap: 8px;
        align-items: flex-end;
        height: 64px;
        width: 80px;
        justify-content: center;
      }
      .scroll-spinner .bar {
        width: 10px;
        height: 24px;
        border-radius: 6px;
        background: linear-gradient(
          180deg,
          var(--color-link, #6366f1) 0%,
          var(--color-google, #4285f4) 100%
        );
        box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);
        animation: scroll-bar 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      }
      .scroll-spinner .bar:nth-child(1) {
        animation-delay: 0s;
      }
      .scroll-spinner .bar:nth-child(2) {
        animation-delay: 0.2s;
      }
      .scroll-spinner .bar:nth-child(3) {
        animation-delay: 0.4s;
      }
      .scroll-spinner .bar:nth-child(4) {
        animation-delay: 0.6s;
      }
      .scroll-spinner .bar:nth-child(5) {
        animation-delay: 0.8s;
      }
      @keyframes scroll-bar {
        0%,
        100% {
          height: 24px;
          background: linear-gradient(
            180deg,
            var(--color-link, #6366f1) 0%,
            var(--color-google, #4285f4) 100%
          );
        }
        50% {
          height: 64px;
          background: linear-gradient(180deg, #ef4444 0%, #6366f1 100%);
        }
      }
    `}</style>
  </div>
);

export default Spinner;
